@if (_document) {
  <div>
    <document-lines-editor
      #lineGrid
      [title]="'Doc::CustomerQuote:ProductsAndServices' | abpLocalization"
      [columnDefs]="columnDefs"
      [rows]="_document.lines"
      [getContextMenuItems]="getContextMenuItems"
      [onCellFocused]="onCellFocused"
      [onRowSelected]="onRowSelected"
      [onCellValueChanged]="onCellValueChanged"
      [treeData]="true"
      [getDataPath]="getDataPath"
      [textLineRole]="textLineRole"
      [chapterLineRole]="chapterLineRole"
      [readonly]="_readonly"
      [canAddLines]="true"
      [addActionBtns]="addActionBtns"
      [actionBtns]="actionBtns"
      [deleteActionEnabled]="deleteActionEnabled"
      [selectedLines]="selectedLines()"
      (deleteLines)="deleteLines()"
      [canExportLines]="false"
      [thirdPartyDoc]="_document"
      [isBusyAdding]="isBusyAdding"
      (onModelUpdated)="onModelUpdated($event)"
      ><button
        before-add-action
        class="btn btn-outline-ligth rounded-circle"
        type="button"
        (click)="openArticleSearch()"
      >
        <i class="digi-out-search"></i></button
    ></document-lines-editor>
  </div>
}
